<template>
    <div style="display:flex; width:100%; height:55px">
      <div class="backInp">
        <input id="searching" class="searching" placeholder="Поиск..." v-model="poisk" />
      </div>
        <span class="material-icons searhIcon" v-bind:style="searchIcon">search</span>
    </div>
</template>

<script>
export default {
    name: 'searchInput',
    data() {
        return {
            searchIcon: '',
            poisk: ''
        };
    },
    watch: {
        searchIcon() {
          const leng = document.getElementById('searching').clientWidth;
        return { 'margin-left': leng/1.2 + 'px'};
      },
      poisk(evt) {
          this.$emit('input', evt);
      }
    }
};
</script>

<style scoped>
.searching {
  border-radius: 25px;
  background:#fff;  
  position: relative;
  width: 100%;
  border: none;
  height: 90%;
  align-self: center;
  padding: 15px;
}
.searching:focus {
  outline: none;
}
.backInp {
  border-radius: 25px;
  background: linear-gradient(to right, #8C30DA, #5C48D4);
  /*height: 55px;*/
  display: flex;
  justify-content: center;
  align-content: center;
  padding-left: 3px;
  padding-right: 3px;
  width: 100%;
  box-shadow: 0 0 5px#8C30DA;
}
.searhIcon {
  /*width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  margin-right: -26px;
  position: absolute;
  z-index: 1;
  float: right; */
  position: relative;
  right: 38px;
  align-self: center;
}
.searhIcon + input {
  padding-right: 26px;
}
</style>